<template>
  <div :class="$style.linksContainer">
    <ul ref="navLinks" :class="$style.navLinks">
      <li v-for="tab in tabs" :key="tab.path" @click="moveUnderline($event)">
        <router-link :to="{ name: tab.name }">{{ tab.label }}</router-link>
      </li>
    </ul>
    <div
      :class="$style.underline"
      :style="{ width: underlineStyle.width + 'px', left: underlineStyle.left + 'px' }"
    ></div>
  </div>
</template>

<script setup>
import { watchEffect, ref } from "vue";
import { useRouter } from "vue-router";

const props = defineProps({
  tabs: Array,
  tabWithChildrenRoutes: Array,
});

const underlineStyle = ref({ width: 0, left: 0 });
const router = useRouter();
const navLinks = ref(null);

const moveUnderline = (event) => {
  const linkElement = event.target.closest("a");
  underlineStyle.value.width = linkElement.offsetWidth;
  underlineStyle.value.left = linkElement.offsetLeft;
};

watchEffect(() => {
  const lastMatched = router.currentRoute.value.matched.slice(-1)[0];
  if (!lastMatched) {
    return;
  }

  let activeRoute = props.tabs.find((tab) => lastMatched.path.endsWith(tab.path.replace("./", "/")));

  if (props.tabWithChildrenRoutes) {
    const matchedTab = props.tabWithChildrenRoutes.find((tab) => lastMatched.path.includes(tab));
    if (matchedTab) {
      activeRoute = props.tabs.find((tab) => tab.path.includes(matchedTab));
    }
  }

  if (activeRoute) {
    const linkElements = navLinks.value.querySelectorAll("a");
    const activeLinkElement = Array.from(linkElements).find((el) =>
      el.getAttribute("href").endsWith(activeRoute.path.replace("./", "/"))
    );

    if (activeLinkElement) {
      underlineStyle.value.width = activeLinkElement.offsetWidth;
      underlineStyle.value.left = activeLinkElement.offsetLeft;
    }
  }
});
</script>

<style module>
.linksContainer {
  position: relative;
}

.navLinks {
  display: flex;
  list-style-type: none;
  padding: 0;
  margin-bottom: 32px;
}

.navLinks li {
  margin-right: 20px;
}

.navLinks a {
  text-decoration: none;
  color: black !important;
  position: relative;
  font-weight: 600;
}

.underline {
  position: absolute;
  bottom: -10px;
  height: 4px;
  background-color: var(--vd-color-blue);
  transition: left 0.3s ease, width 0.3s ease;
}
</style>
